import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Container,
    Divider,
} from '@mui/material';
import {SyntheticEvent, useState} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {ContactSection} from "./ContactSection";
import {ProjectsSection} from "./ProjectsSection";
import {CVSection} from "./CVSection";


export const HomeContent = () => {
    const [expanded, setExpanded] = useState<string | false>("");

    const handleChange =
        (panel: string) =>
            (_event: SyntheticEvent, isExpanded: boolean) => {
                setExpanded(isExpanded ? panel : false);
            };

    return (
        <div style={{
            padding: '0 auto',
            zIndex: '2'
        }}>

            <Container
                className="custom-scrollbar"
                maxWidth="md"
                sx={{
                    py: 4,
                    maxHeight: "100dvh",
                    overflow: "auto"
                }}
            >
                <Typography
                    variant={"h1"}
                    sx={{fontSize: {xs: "2rem", sm: "3rem", md: "4rem"}}}>
                    Cristian Hilohi
                </Typography>

                <Typography
                    variant={"h2"}
                    color={"text.secondary"}
                    sx={{fontSize: {xs: "1.5rem", sm: "2rem", md: "2.5rem"}}}>
                    Software developer
                </Typography>

                <Divider sx={{my: {xs: 2, sm: 3, md: 4,}}}
                />

                {/* Contact */}
                <Accordion
                    expanded={expanded === "contact"}
                    onChange={handleChange("contact")}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography variant="h3" sx={{fontSize: "16px"}}>
                            Contact
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ContactSection/>
                    </AccordionDetails>
                </Accordion>

                {/* Projects */}
                <Accordion
                    expanded={expanded === "projects"}
                    onChange={handleChange("projects")}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography variant="h3" sx={{fontSize: "16px"}}>
                            Projects
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ProjectsSection/>
                    </AccordionDetails>
                </Accordion>

                {/* Curriculum Vitae */}
                <Accordion
                    expanded={expanded === "cv"}
                    onChange={handleChange("cv")}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography variant="h3" sx={{fontSize: "16px"}}>
                            Curriculum Vitae
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CVSection/>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </div>
    )
}